module.exports = __webpack_public_path__ + "img/runners.9e22fa71.jpg";